import React from 'react';
import IconButton from '@mui/material/IconButton';

interface GenericButtonProps {
    icon: React.ReactNode; // change to string or see how IconButton receives the icon.
    onClick: () => void;
}

const GenericButton: React.FC<GenericButtonProps> = ({ icon, onClick }) => {
    return (
        <IconButton
            onClick={onClick}
            sx={{
                width: '15px',
                height: '15px',
                padding: 0, // To ensure the size is strictly controlled
                margin: '0 5px' // Spread 10px apart (5px left + 5px right)
            }}
        >
            {icon}
        </IconButton>
    );
};

export default GenericButton;
